import { Layout, MyProjects } from "../../components";

const Projects = () => {
  return (
    <Layout>
      <MyProjects />
    </Layout>
  );
};

export { Projects };
